// Single source of truth for editable copy and external links.
// Keep this minimal so a Squarespace rebuild can mirror it 1:1.

export const SITE = {
  brand: 'Shadows of the Infinite',
  archiveUrl: 'https://cinder-archive.subscribepage.io',
  inquiriesEmail: 'ip@shadowsoftheinfinite.studio',
  author: 'Federico C. Quiñones',
};
